import { usePhotoBankStore, useTilesStore } from 'stores/RootStoreProvider'
import { useMobxSelector } from 'utils/mobx/useMobxSelector'
import {
  getCartUpsellAnalyticsProps,
  getCartUpsellCardTitleKey,
  getCartUpsellFlowImageUrls,
  getCartUpsellThumbnail,
} from '../cartUpsells.registry'
import { CART_UPSELL_IDS } from '../cartUpsells.schemas'
import type { CartUpsellCardData } from '../cartUpsells.types'
import { getCartUpsellOffer, useCartUpsellRecords } from '../cartUpsellsStorage'
import { hasCartUpsellTiles } from '../cartUpsellTiles'

export function useOfferedCartUpsells(): CartUpsellCardData[] {
  const records = useCartUpsellRecords()
  const photoBankStore = usePhotoBankStore()
  const tilesStore = useTilesStore()
  return useMobxSelector(
    () =>
      CART_UPSELL_IDS.flatMap((id): CartUpsellCardData[] => {
        const offer = getCartUpsellOffer(records[id])
        if (!offer || hasCartUpsellTiles(tilesStore.tiles, id)) return []
        const sourcePhotos = offer.sourcePhotoUids.flatMap((uid) => {
          const photo = photoBankStore.remotePhotosMap.get(uid)
          return photo ? [photo] : []
        })
        // A source photo leaves the bank when the user deletes it or its TTL expires on load.
        if (sourcePhotos.length !== offer.sourcePhotoUids.length) return []
        return [
          {
            id,
            titleKey: getCartUpsellCardTitleKey(id, offer),
            thumbnail: getCartUpsellThumbnail(id, offer, sourcePhotos),
            flowImageUrls: getCartUpsellFlowImageUrls(id, offer),
            analyticsProps: getCartUpsellAnalyticsProps(id, offer),
          },
        ]
      }),
    [records, photoBankStore, tilesStore]
  )
}
